/* dropedo Produktseite.
   Farbmuster aus den Kugeldaten, Ausführungen als Auswahl (jede ist ein eigenes Produkt),
   Menge mal Preis, feste Kaufleiste am Handy. Kein Modul, damit es ohne Import Map läuft. */
(function () {
  var wurzel = document.getElementById('ds-produkt');
  if (!wurzel) return;
  var cfg = wurzel.dataset;
  var norm = function (s) { return (s || '').toUpperCase().replace(/[\s\-_/.]/g, ''); };
  var geldFormat = cfg.geld || '{{amount_with_comma_separator}} €';

  // Preise aus /products/<handle>.js stehen in Cent.
  function euroAusCent(cent) {
    var v = Number(cent) / 100;
    var mitKomma = v.toFixed(2).replace('.', ',');
    return geldFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, mitKomma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, mitKomma.replace(',00', ''))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, v.toFixed(0))
      .replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  }

  var el = {
    titel: wurzel.querySelector('[data-titel-ton]'),
    titelArt: wurzel.querySelector('[data-titel-art]'),
    effekt: wurzel.querySelector('[data-effekt]'),
    artikel: wurzel.querySelector('[data-artikel-titel]'),
    preis: wurzel.querySelector('[data-preis]'),
    rechnung: wurzel.querySelector('[data-preis-rechnung]'),
    grundpreis: wurzel.querySelector('[data-grundpreis]'),
    preiszeile: wurzel.querySelector('[data-preiszeile]'),
    menge: wurzel.querySelector('.dp-menge-feld'),
    variante: wurzel.querySelector('input[name="id"]'),
    kaufen: wurzel.querySelector('.dp-kaufen'),
    buehne: wurzel.querySelector('[data-buehne]'),
    thumbs: wurzel.querySelector('[data-thumbs]'),
    beschreibung: wurzel.querySelector('.dp-beschreibung'),
    leisteTitel: wurzel.querySelector('[data-leiste-titel]'),
    leistePreis: wurzel.querySelector('[data-leiste-preis]'),
    versand: wurzel.querySelector('[data-versand]'),
    porto: wurzel.querySelector('[data-porto]'),
    portoWort: wurzel.querySelector('[data-porto-wort]'),
    endpreisSatz: wurzel.querySelector('[data-endpreis-satz]'),
    pfad: wurzel.querySelector('[data-pfad-ton]'),
    knopfSumme: wurzel.querySelector('[data-knopf-summe]')
  };
  var einzelpreis = null; // in Cent, sobald bekannt
  // Gibt es Ausfuehrungen, steht die gewaehlte ("Standard-Set") in der festen Kaufleiste unter dem Preis (seit 08.10.2026;
  // vorher oben statt des Farbnamens). Die Farbe zeigt das Muster links daneben.
  var ausfName = null;
  // Zweitfarbe einer Zweifarb-Lackierung als Zusatz (seit 07.10.2026, assets/ds-zweifarb.js): Preis und Gewicht
  // des Partner-Sets in Cent bzw. Gramm, 0 ohne Haken. Kommt per Ereignis "ds:zusatz" an #ds-produkt.
  var zusatz = { preis: 0, gewicht: 0, anzahl: 0 };
  // Versandstufen je Land (seit 08.10.2026) aus snippets/ds-versandsatz.liquid, am Preisblock als "bis Gramm:Cent|…"
  // ("-" = ohne Obergrenze): data-stufen fuer das Land des Besuchers, data-stufen-de fuer den Endpreis-Satz.
  function stufenLesen(text) {
    return String(text || '').split('|').filter(Boolean).map(function (t) {
      var x = t.split(':');
      return { bis: x[0] === '-' ? Infinity : Number(x[0]), cent: Number(x[1]) };
    });
  }
  var versandLand = el.versand ? el.versand.dataset.land || '' : '';
  var stufenKunde = stufenLesen(el.versand && el.versand.dataset.stufen);
  var stufenDe = stufenLesen(el.versand && el.versand.dataset.stufenDe);

  /* ---------- Preis und Menge ---------- */
  // Der grosse Preis ist ueberall im Shop der Stueckpreis und bleibt es auch hier.
  // Die Gesamtsumme steht ab zwei Stueck im Kaufknopf (seit 08.10.2026, siehe unten).
  function preisZeigen() {
    if (einzelpreis === null) return;
    var n = Math.max(1, parseInt(el.menge.value, 10) || 1);
    el.preis.textContent = euroAusCent(einzelpreis);
    if (el.leistePreis) el.leistePreis.textContent = euroAusCent(einzelpreis + zusatz.preis);
    // Porto neben dem Preis gilt fuer das, was in den Warenkorb kommt (Menge, mit Zweitfarbe beide Sets).
    // Es aendert sich nur der Text in der Zeile, darum verschiebt sich nichts.
    var porto = portoCent((stueckGewicht() + zusatz.gewicht) * n, stufenKunde);
    portoZeigen(porto);
    endpreisSatzZeigen();
    // Ab zwei Stueck steht die Summe seit 08.10.2026 im Kaufknopf statt als Zeile "2 Stück · Gesamt …" im
    // Preisblock: die Zeile erschien ueber Auswahl und Mengenfeld und schob beides weg, waehrend man "+" klickte
    // (Anton: "best practice konversionoptimiert", dann "mach"). Mit Zweitfarbe genauso (seit 21.10.2026, Antons
    // "konsistent machen"): "Beide Farben · 33,80 €" bzw. "2 Stück je Farbe · 67,60 €" im Knopf statt der Zeile
    // "Beide Farben: … · mit Versand …" am Preis; das Porto neben dem Preis rechnet beide Sets schon mit.
    // Der grosse Preis bleibt der Stueckpreis.
    el.rechnung.hidden = true;
    if (zusatz.preis) {
      var farben = zusatz.anzahl > 1 ? (zusatz.anzahl + 1) + ' Farben' : 'Beide Farben';
      knopfSummeZeigen((n > 1 ? n + ' Stück je Farbe · ' : farben + ' · ') + euroAusCent((einzelpreis + zusatz.preis) * n));
      return;
    }
    knopfSummeZeigen(n > 1 ? n + ' Stück · ' + euroAusCent(einzelpreis * n) : '');
  }
  function knopfSummeZeigen(text) {
    if (!el.knopfSumme) return;
    el.knopfSumme.textContent = text;
    el.knopfSumme.hidden = !text || el.kaufen.disabled;
  }

  // Porto fuer ein Gewicht nach den Stufen eines Landes; null = kein Satz (dann "zzgl. Versandkosten" ohne Betrag)
  function stueckGewicht() { return el.versand ? Number(el.versand.dataset.gewicht) || 0 : 0; }
  function portoCent(gramm, stufen) {
    if (!gramm) return null;
    for (var i = 0; i < stufen.length; i++) if (gramm <= stufen[i].bis) return stufen[i].cent;
    return null;
  }
  function portoZeigen(porto) {
    if (!el.porto) return;
    el.porto.textContent = porto === null ? '' : euroAusCent(porto);
    el.porto.hidden = porto === null;
    if (el.portoWort) el.portoWort.textContent = porto === null ? 'Versandkosten' : 'Versand (' + versandLand + ')';
  }
  // Endpreis eines Stuecks nach Deutschland als Satz im Produkttext (fuer Preisvergleiche, snippets/ds-produkttext.liquid)
  function endpreisSatzZeigen() {
    if (!el.endpreisSatz) return;
    var porto = portoCent(stueckGewicht(), stufenDe);
    el.endpreisSatz.hidden = porto === null;
    if (porto !== null) el.endpreisSatz.querySelector('[data-endpreis-betrag]').textContent = euroAusCent(einzelpreis + porto);
  }
  wurzel.addEventListener('ds:zusatz', function (e) {
    var d = e.detail || {};
    zusatz = { preis: Number(d.preis) || 0, gewicht: Number(d.gewicht) || 0, anzahl: Number(d.anzahl) || (d.preis ? 1 : 0) };
    preisZeigen();
  });
  // Grundpreis nach § 4 PAngV, klein in Klammern neben dem Preis: "(109,80 € / l)".
  // Beim ersten Aufbau setzt ihn Liquid (snippets/ds-grundpreis.liquid, dasselbe Format);
  // wechselt der Besucher die Ausführung, steht ein anderes Produkt im Rahmen, und der
  // Wert kommt aus dessen JSON. Shopify liefert ihn dort mit, sobald an der Variante
  // showUnitPrice gesetzt ist.
  var EINHEIT = { m2: 'm²', m3: 'm³' };
  function grundpreisZeigen(v) {
    if (!el.grundpreis) return;
    var m = v && v.unit_price_measurement;
    var da = !!(m && v.unit_price && m.reference_unit);
    el.grundpreis.hidden = !da;
    if (el.preiszeile) el.preiszeile.classList.toggle('dp-preiszeile--grundpreis', da);
    if (!da) return;
    var bezug = String(m.reference_unit).toLowerCase();
    var wert = Number(m.reference_value) || 1;
    var vorwort = document.createElement('span');
    vorwort.className = 'visually-hidden';
    vorwort.textContent = 'Grundpreis: ';
    el.grundpreis.textContent = '';
    el.grundpreis.appendChild(vorwort);
    el.grundpreis.appendChild(document.createTextNode(
      '(' + euroAusCent(v.unit_price) + ' / ' + (wert === 1 ? '' : wert + ' ') + (EINHEIT[bezug] || bezug) + ')'));
  }

  /* ---------- Wunschfarbe: ohne Farbcode kein Kauf ---------- */
  // Dawns <product-form> schickt den Warenkorb-Aufruf selbst ab und setzt novalidate,
  // die Browserpruefung greift also nicht. Deshalb haengt der Waechter am Elternelement
  // in der Einfangphase: die laeuft sicher vor den Zuhoerern am Formular selbst.
  (function () {
    var felder = wurzel.querySelectorAll('[data-wunsch-pflicht]');
    if (!felder.length) return;
    var rahmen = wurzel.querySelector('product-form');
    var fehler = wurzel.querySelector('[data-wunsch-fehler]');
    if (!rahmen) return;

    function leer() {
      return Array.prototype.filter.call(felder, function (f) { return !f.value.trim(); });
    }

    rahmen.addEventListener('submit', function (ev) {
      var offen = leer();
      if (!offen.length) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      offen.forEach(function (f) { f.setAttribute('aria-invalid', 'true'); });
      if (fehler) {
        // Der Kurzname steht am Feld, nicht in der Beschriftung: "Automarke und Modell"
        // ergaebe im Satz sonst "den Farbcode und Automarke und Modell".
        fehler.textContent = 'Bitte tragen Sie noch ' + offen.map(kurzname).join(' und ') + ' ein.';
        fehler.hidden = false;
      }
      offen[0].focus();
      offen[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, true);

    function kurzname(f) {
      return f.getAttribute('data-wunsch-pflicht') || 'die Angabe';
    }

    Array.prototype.forEach.call(felder, function (f) {
      f.addEventListener('input', function () {
        f.removeAttribute('aria-invalid');
        if (fehler && !leer().length) fehler.hidden = true;
      });
    });
  })();

  wurzel.querySelectorAll('[data-menge]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = parseInt(el.menge.value, 10) || 1;
      el.menge.value = Math.max(1, n + parseInt(b.dataset.menge, 10));
      preisZeigen();
    });
  });
  el.menge.addEventListener('input', preisZeigen);
  el.menge.addEventListener('change', function () {
    el.menge.value = Math.max(1, parseInt(el.menge.value, 10) || 1);
    preisZeigen();
  });

  /* ---------- Bildwechsel ---------- */
  // Tafeln in den verdeckten Ansichten tragen data-src (Welle D): sie laden beim ersten Zeigen
  // oder, wenn die Seite fertig ist, im Leerlauf - nicht mehr vor dem groessten Bild.
  function tafelLaden(f) {
    if (!f) return;
    f.querySelectorAll('img[data-src]').forEach(function (i) {
      if (i.dataset.srcset) i.srcset = i.dataset.srcset;
      i.src = i.dataset.src;
      i.removeAttribute('data-src'); i.removeAttribute('data-srcset');
    });
  }
  // Im Leerlauf vorladen, aber nicht bei "Daten sparen" oder langsamem Netz (06.10.2026): gedrosselt holte die
  // Seite nach dem Laden noch 250 KB Tafeln, die die meisten nie aufmachen. Dann laden sie beim ersten Zeigen.
  function sparsam() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$|^3g$/.test(c.effectiveType || '')));
  }
  function alleTafeln() { if (!sparsam()) el.buehne.querySelectorAll('.dp-foto').forEach(tafelLaden); }
  if (document.readyState === 'complete') {
    (window.requestIdleCallback || setTimeout)(alleTafeln);
  } else {
    window.addEventListener('load', function () { (window.requestIdleCallback || setTimeout)(alleTafeln); });
  }
  function zeigen(was) {
    tafelLaden(el.buehne.querySelector('.dp-foto[data-foto="' + was + '"]'));
    wurzel.querySelectorAll('.dp-thumb').forEach(function (t) {
      var an = t.dataset.zeigt === was;
      t.classList.toggle('an', an);
      t.setAttribute('aria-selected', an ? 'true' : 'false');
    });
    var ton = el.buehne.querySelector('[data-ton-flaeche]');
    if (ton) ton.classList.toggle('an', was === 'ton');
    // Bei der grossen Farbansicht ist die ganze Flaeche der Ton, das kleine Feld darauf
    // waere dann sinnlos.
    var feld = el.buehne.querySelector('[data-farbfeld]');
    if (feld) feld.hidden = was === 'ton';
    el.buehne.querySelectorAll('.dp-foto').forEach(function (f) { f.classList.toggle('an', f.dataset.foto === was); });
  }
  function thumbsVerbinden() {
    wurzel.querySelectorAll('.dp-thumb').forEach(function (t) {
      if (t.dataset.gebunden) return;
      t.dataset.gebunden = '1';
      t.addEventListener('click', function () { zeigen(t.dataset.zeigt); });
    });
  }
  thumbsVerbinden();

  /* ---------- Lieferumfang als Kacheln ---------- */
  var umfang = wurzel.querySelector('[data-lieferumfang]');

  // "2x20ml" heisst zwei Flaschen zu 20 ml, deshalb wird jede Angabe auf Flaschen aufgeloest
  function mengenAusTitel(titel) {
    var roh = titel.match(/\d+\s*x\s*\d+\s*ml|\d+\s*ml/gi) || [];
    var flach = [];
    roh.forEach(function (x) {
      var t = x.replace(/\s+/g, '').toLowerCase();
      var m = t.match(/^(\d+)x(\d+)ml$/);
      if (m) { for (var i = 0; i < parseInt(m[1], 10); i++) flach.push(m[2] + ' ml'); }
      else flach.push(t.replace('ml', ' ml'));
    });
    return flach;
  }

  function teileAusTitel(T) {
    var liste = [{ id: 'basis', n: 1, text: '' }];
    if (T.indexOf('KLARLACK') >= 0) liste.push({ id: 'klar', n: 1, text: '' });
    if (T.indexOf('GRUNDTON') >= 0) liste.push({ id: 'grundton', n: 1, text: '' });
    var kunst = T.indexOf('KUNSTSTOFFGRUNDIERUNG') >= 0;
    var metall = T.indexOf('METALLGRUNDIERUNG') >= 0;
    if (kunst || metall || T.indexOf('GRUNDIERUNG') >= 0) {
      liste.push({ id: 'grund', n: kunst && metall ? 2 : 1, text: kunst && metall ? 'Metall und Kunststoff' : '' });
    }
    return liste;
  }

  function umfangSetzen(titel) {
    if (!umfang) return;
    var T = (titel || '').toUpperCase();
    var teile = teileAusTitel(T);
    var flach = mengenAusTitel(titel || '');
    var flaschen = teile.reduce(function (a, x) { return a + x.n; }, 0);
    var passt = flach.length === flaschen;
    var drin = {}, pos = 0;
    teile.forEach(function (c) {
      var vols = flach.slice(pos, pos + c.n);
      pos += c.n;
      var txt = '';
      if (passt && vols.length === c.n) {
        var gleich = vols.every(function (x) { return x === vols[0]; });
        txt = c.n > 1 ? (gleich ? c.n + ' × ' + vols[0] : vols.join(' + ')) : vols[0];
      }
      if (c.text) txt = txt ? txt + ', ' + c.text : c.text;
      drin[c.id] = txt;
    });
    umfang.querySelectorAll('.dp-umfang-teil').forEach(function (li) {
      var id = li.dataset.teil;
      var an = Object.prototype.hasOwnProperty.call(drin, id);
      li.hidden = !an;
      var nm = li.querySelector('[data-name]');
      if (nm && an && !nm.textContent) nm.textContent = nm.dataset.name;
      var m = li.querySelector('[data-menge]');
      if (m && an && drin[id] !== null) m.textContent = drin[id] || '';
    });
    // Spaltenzahl folgt der Zahl der Kacheln (CSS: data-anzahl, vier werden im schmalen Kasten 2 x 2)
    var liste = umfang.querySelector('.dp-umfang-liste');
    if (liste) liste.dataset.anzahl = String(teile.length);
    umfang.hidden = false;
  }
  if (cfg.warenart !== 'zubehoer') umfangSetzen(cfg.titel);

  /* ---------- Ueberschrift ---------- */
  // Der Lagertitel schreibt Marke und Farbname in Grossbuchstaben. Der Farbcode muss so
  // bleiben, alles andere wird entschrien. Der Name selbst bleibt der aus dem Titel,
  // damit auf der Seite nichts anderes steht als im Angebot.
  var kopfRoh = el.titel ? el.titel.textContent.trim().replace(/\s+/g, ' ') : '';

  function schoenerKopf(roh, code) {
    var codeN = code ? norm(code) : '';
    return (roh || '').split(/(\s+|\/)/).map(function (w) {
      if (!/^[A-ZÄÖÜ]{4,}$/.test(w)) return w;
      if (codeN && norm(w) === codeN) return w;
      return w.charAt(0) + w.slice(1).toLowerCase();
    }).join('');
  }

  function kopfSchreiben(code) {
    var t = schoenerKopf(kopfRoh, code);
    // Zweitcodes zusammenhalten ("LZ9Y / L8"): kopfRoh hat alle Leerzeichen vereinheitlicht,
    // auch die geschuetzten aus dem Theme - ohne sie bricht die Zeile am Handy nach dem Schraegstrich.
    if (el.titel) el.titel.textContent = t.replace(/ \/ /g, '\u00a0/\u00a0');
    if (el.pfad) el.pfad.textContent = t.length > 46 ? t.slice(0, 46) + '…' : t;
  }
  // Zubehoer traegt keinen Farbton: die Ueberschrift ist der Produkttitel und bleibt genau
  // so stehen, wie er im Shop steht. Entschreien wuerde aus „PROFI MASKING TAPE" ein
  // „Profi Masking Tape" machen und damit von der Trefferliste abweichen.
  var istLackstift = cfg.warenart !== 'zubehoer';
  if (istLackstift) kopfSchreiben('');

  // Zweite Zeile der Ueberschrift: welche Ausfuehrung liegt vor
  function artAusTitel(titel) {
    var T = (titel || '').toUpperCase();
    if (T.indexOf('GRUNDIERUNG') >= 0) return 'Lackstift-Set mit Grundierung';
    if (T.indexOf('GRUNDTON') >= 0) return 'Lackstift-Set mit Grundton';
    if (T.indexOf('KLARLACK') >= 0) return 'Lackstift-Set mit Klarlack';
    return titel;
  }

  /* ---------- Aufklapper: immer nur einer offen ----------
     Das name-Attribut im HTML macht das von selbst, aber erst ab Safari 17.2 und
     Firefox 130. Wo das fehlt, klappt dieser Zuhoerer die anderen zu. */
  var falten = [].slice.call(wurzel.querySelectorAll('details[name]'));
  if (falten.length > 1 && !('name' in document.createElement('details'))) {
    falten.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var gruppe = d.getAttribute('name');
        falten.forEach(function (a) { if (a !== d && a.getAttribute('name') === gruppe) a.open = false; });
      });
    });
  }

  /* ---------- Feste Kaufleiste ---------- */
  // Seit 06.10.2026 schaltet sie ein Inline-Skript direkt hinter ihrem Markup (ds-produkt.liquid), damit sie
  // nicht auf dieses Skript warten muss. Hier steht nur noch, was sich spaeter aendert: die Ausfuehrung im Titel.

  /* ---------- Farbmuster ---------- */
  function hell(hex) {
    var n = parseInt(hex, 16);
    var r = (n >> 16 & 255) / 255, g = (n >> 8 & 255) / 255, b = (n & 255) / 255;
    var f = function (c) { return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
  }
  function titelTraegtCode(titelGross, codeN) {
    var teile = titelGross.split(/[\s/,]+/).map(norm).filter(Boolean);
    for (var i = 0; i < teile.length; i++) {
      var zus = '';
      for (var k = 0; k < 3 && i + k < teile.length; k++) {
        zus += teile[i + k];
        if (zus === codeN) return true;
        if (zus.length >= codeN.length) break;
      }
    }
    return false;
  }

  // Standohyd-Basislack braucht auch als Uniton Klarlack (wie ds-produkt.liquid seit 24.09.). Liegt er im Set,
  // heisst es seit 08.10.2026 „Klarlack ist dabei“ - „braucht Klarlack“ las sich dort wie ein Zusatzkauf.
  function effektText(istEffekt, titel) {
    var dabei = istLackstift && String(titel || '').toUpperCase().indexOf('KLARLACK') >= 0;
    return (istEffekt ? 'Effektlack, ' : 'Unilack, ') + (dabei ? 'Klarlack ist dabei' : 'braucht Klarlack');
  }

  function tonSetzen(marke, ton) {
    var hex = '#' + ton[2];
    // Lackart fuer das Lackmuster (dropedo-produkt.css), wenn das Metafeld fehlte
    wurzel.setAttribute('data-effektlack', ton[3] ? '1' : '0');
    var flaeche = wurzel.querySelector('[data-ton-flaeche]');
    flaeche.style.setProperty('--ton', hex);
    flaeche.hidden = false;
    var codeEl = wurzel.querySelector('[data-ton-code]');
    codeEl.textContent = marke.name + ' ' + ton[0];
    codeEl.classList.toggle('auf-hell', hell(ton[2]) > 0.45);

    // Das Farbfeld auf dem Foto tragt denselben Ton. Fehlt es im Markup, weil beim
    // Seitenaufbau noch kein Farbwert bekannt war, wird es hier nachgesetzt.
    var feld = el.buehne.querySelector('[data-farbfeld]');
    if (!feld) {
      feld = document.createElement('span');
      feld.className = 'dp-farbe';
      feld.setAttribute('data-farbfeld', '');
      feld.setAttribute('aria-hidden', 'true');
      el.buehne.appendChild(feld);
    }
    feld.style.setProperty('--ton', hex);

    var tb = wurzel.querySelector('[data-zeigt="ton"]');
    tb.hidden = false;
    tb.querySelector('[data-ton-thumb]').style.background = hex;
    thumbsVerbinden();

    wurzel.querySelectorAll('[data-ton-probe]').forEach(function (p) { p.style.background = hex; });
    kopfSchreiben(ton[0]);
    if (el.effekt) {
      el.effekt.textContent = effektText(ton[3], cfg.titel);
      el.effekt.hidden = false;
    }
    aehnlicheBauen(marke, ton);
    ausfuehrungenLaden(marke.name, ton[0]);
  }

  function aehnlicheBauen(marke, ton) {
    var ziel = document.getElementById('ds-aehnliche');
    if (!ziel || !window.DROPEDO_TOENE) return;
    var liste = window.DROPEDO_TOENE[marke.key] || [];
    if (liste.length < 4) return;
    function rgb(hex) { var n = parseInt(hex, 16); return [(n >> 16 & 255), (n >> 8 & 255), (n & 255)]; }
    var a = rgb(ton[2]);
    var nah = liste.filter(function (t) { return t[0] !== ton[0]; }).map(function (t) {
      var b = rgb(t[2]);
      return { t: t, d: Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2) + Math.pow(a[2] - b[2], 2) };
    }).sort(function (x, y) { return x.d - y.d; }).slice(0, 8);
    // Die Kacheln zeigen zuerst auf die Markenseite, nicht auf eine Suchtrefferseite.
    // Sobald der Abschnitt sichtbar wird, wird daraus die echte Produktseite.
    var markeUrl = '/collections/' + marke.handle;
    ziel.querySelector('[data-aehnliche-raster]').innerHTML = nah.map(function (n) {
      return '<li><a class="da-kachel" href="' + markeUrl + '" data-code="' + n.t[0] +
        '" data-lackart="' + (n.t[3] ? 'effekt' : 'uni') +
        '" style="--ton:#' + n.t[2] + '"><i></i><b>' + n.t[0] + '</b><span>' + n.t[1] + '</span></a></li>';
    }).join('');
    ziel.hidden = false;
    produktLinksNachziehen(ziel, marke);
    var h = ziel.querySelector('[data-aehnliche-titel]');
    if (h && h.dataset.vorlage) h.textContent = h.dataset.vorlage.split('MARKE').join(marke.name);
  }

  function produktLinksNachziehen(ziel, marke) {
    var kacheln = [].slice.call(ziel.querySelectorAll('.da-kachel[data-code]'));
    if (!kacheln.length) return;
    var gelaufen = false;
    var markeGross = marke.name.toUpperCase();

    function holen() {
      if (gelaufen) return;
      gelaufen = true;
      kacheln.forEach(function (a) {
        var code = a.dataset.code;
        var url = cfg.suche + '/suggest.json?q=' + encodeURIComponent(code + ' ' + marke.name) +
          '&resources[type]=product&resources[limit]=5&resources[options][fields]=title' +
          '&resources[options][unavailable_products]=hide';
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          var codeN = norm(code);
          var treffer = ps.filter(function (p) {
            var T = p.title.toUpperCase();
            return T.indexOf('LACKSTIFT') === 0 && T.indexOf(markeGross) >= 0 && titelTraegtCode(T, codeN);
          }).sort(function (x, y) { return x.title.length - y.title.length; })[0];
          if (treffer) a.href = treffer.url.split('?')[0];
        }).catch(function () {});
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es, o) {
        if (es[0].isIntersecting) { holen(); o.disconnect(); }
      }, { rootMargin: '300px' }).observe(ziel);
    } else {
      holen();
    }
  }

  // Seit dem 22.09. stehen Farbwert, Farbcode und Marke in den Metafeldern und damit schon
  // im HTML: die Farbflaeche ist fertig, bevor JavaScript ueberhaupt laeuft. Geholt wird die
  // Kugeldatei dann nur noch fuer die aehnlichen Toene. Traegt ein Produkt noch keine
  // Metafelder, springt die alte Suche ueber den Titel unveraendert wieder ein.
  if (cfg.hex) {
    kopfSchreiben(cfg.code || '');
    thumbsVerbinden();
    wurzel.querySelectorAll('[data-ton-probe]').forEach(function (p) { p.style.background = cfg.hex; });
    if (cfg.code) ausfuehrungenLaden(cfg.marke || '', cfg.code);
  }

  function markeAusDaten(d) {
    var wunsch = (cfg.marke || '').toUpperCase();
    var gefunden = null;
    d.marken.forEach(function (m) {
      var marke = { key: m[0], name: m[1], handle: m[2] };
      if (marke.name.toUpperCase() === wunsch || marke.key === wunsch) gefunden = marke;
    });
    return gefunden;
  }

  function datenLaden() {
    fetch(cfg.daten, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
      window.DROPEDO_TOENE = d.toene;

      if (cfg.hex) {
        var marke = markeAusDaten(d);
        if (marke) {
          aehnlicheBauen(marke, [cfg.code || '', cfg.farbname || '',
            cfg.hex.replace('#', ''), cfg.effektlack === '1' ? 1 : 0]);
        }
        return;
      }

      var T = cfg.titel.toUpperCase();
      var treffer = null;
      d.marken.forEach(function (m) {
        var mk = { key: m[0], name: m[1], handle: m[2] };
        if (T.indexOf(mk.key) < 0 && T.indexOf(mk.name.toUpperCase()) < 0) return;
        (d.toene[mk.key] || []).forEach(function (t) {
          if (treffer && treffer.ton[0].length >= t[0].length) return;
          if (titelTraegtCode(T, norm(t[0]))) treffer = { marke: mk, ton: t };
        });
      });
      if (treffer) tonSetzen(treffer.marke, treffer.ton);
    }).catch(function () {});
  }
  // Ohne Farbton muss die 420 KB grosse Farbdatei gar nicht erst geholt werden - und
  // seit dem 22.09. auch dann nicht, wenn es die Flaeche fuer die aehnlichen Toene gar
  // nicht mehr gibt. Anton: "der bereich macht da ueberhaupt kein sinn weg ueberall".
  // Damit spart jede Produktseite einen Abruf von 420 KB.
  // Das Skript laeuft seit 06.10.2026 "async", also womoeglich bevor der Abschnitt ds-aehnliche (er steht hinter
  // diesem) gelesen ist; deshalb wird hier notfalls auf DOMContentLoaded gewartet.
  function aehnlicheStarten() { if (istLackstift && document.getElementById('ds-aehnliche')) datenLaden(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aehnlicheStarten);
  else aehnlicheStarten();

  /* ---------- Ausführungen: je eine eigene Produktseite, hier als Auswahl ---------- */
  var ausfGelaufen = false;
  var optionen = [];

  // Bis 08.10.2026 hiess das erste "Set mit Klarlack" - neben "Mit Grundierung" klang das, als fehle dort
  // der Klarlack. Er ist in jeder Ausfuehrung, unterscheiden tut sie nur Grundton und Grundierung.
  function artVon(titel) {
    var t = titel.toUpperCase();
    if (t.indexOf('GRUNDIERUNG') >= 0) return { name: 'Mit Grundierung', rang: 3 };
    if (t.indexOf('GRUNDTON') >= 0) return { name: 'Mit Grundton', rang: 2 };
    return { name: 'Standard-Set', rang: 1 };
  }

  function bildUrl(u, breite) {
    var pfad = u.indexOf('//') === 0 ? 'https:' + u : u;
    return pfad + (pfad.indexOf('?') >= 0 ? '&' : '?') + 'width=' + breite;
  }

  // Beim Wechsel der Ausfuehrung wurde die Galerie frueher abgeraeumt und neu gebaut.
  // Ein frisch erzeugtes <img> ist beim Einhaengen nie "complete", also wartete der
  // Umschalter jedes Mal auf das load-Ereignis - auch beim Zurueckschalten auf ein Bild,
  // das der Browser laengst im Zwischenspeicher hat. Genau das war die Verzoegerung, und
  // waehrend sie lief, stand die alte Ansicht noch da und die neue noch nicht.
  //
  // Jetzt bekommt jede Ausfuehrung einen eigenen Satz Bilder. Er wird einmal gebaut und
  // bleibt danach in der Buehne stehen: unsichtbar, aber geladen und dekodiert. Der
  // Wechsel ist nur noch ein Klassentausch - beide Ebenen liegen uebereinander, die eine
  // blendet auf, die andere ab. Zurueckschalten kostet gar nichts mehr.
  var saetze = {};
  var satzJetzt = cfg.handle;

  // Der vom Server gelieferte Satz gehoert der Seite, auf der wir stehen. Aufbau,
  // Fundort, Anwendung und das Farbfeld sind ausgenommen: die gelten fuer jede
  // Ausfuehrung und duerfen beim Wechsel nicht verschwinden.
  saetze[cfg.handle] = {
    fotos: Array.prototype.filter.call(el.buehne.querySelectorAll('.dp-foto'), function (f) {
      return !f.classList.contains('dp-foto--aufbau') && !f.classList.contains('dp-foto--info');
    }),
    thumbs: Array.prototype.filter.call(el.thumbs.querySelectorAll('.dp-thumb'), function (t) {
      return !t.classList.contains('dp-thumb--aufbau') && !t.classList.contains('dp-thumb--ton');
    })
  };

  function satzBauen(handle, p) {
    if (saetze[handle]) return saetze[handle];
    var bilder = ((p && p.images) || []).slice(0, 4);
    if (!bilder.length) return null;
    var vorFoto = el.buehne.querySelector('.dp-foto--aufbau, .dp-foto--info, [data-ton-flaeche]');
    var vorThumb = el.thumbs.querySelector('.dp-thumb--aufbau, .dp-thumb--ton');
    var satz = { fotos: [], thumbs: [] };
    bilder.forEach(function (u, i) {
      var id = handle + '#' + i;

      var d = document.createElement('div');
      d.className = 'dp-foto';
      d.dataset.foto = id;
      var img = document.createElement('img');
      img.alt = p.title || '';
      img.decoding = 'async';
      img.src = bildUrl(u, 1200);
      d.appendChild(img);
      el.buehne.insertBefore(d, vorFoto);
      satz.fotos.push(d);

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dp-thumb';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', 'false');
      b.dataset.zeigt = id;
      b.hidden = true;                 // gehoert einer anderen Ausfuehrung
      b.innerHTML = '<img src="' + bildUrl(u, 200) + '" alt="" loading="lazy">';
      el.thumbs.insertBefore(b, vorThumb);
      satz.thumbs.push(b);
    });
    saetze[handle] = satz;
    thumbsVerbinden();
    return satz;
  }

  function galerieZeigen(handle, p) {
    if (handle === satzJetzt) return;
    var satz = saetze[handle] || satzBauen(handle, p);
    if (!satz || !satz.fotos.length) return;

    function um() {
      Object.keys(saetze).forEach(function (h) {
        saetze[h].thumbs.forEach(function (t) { t.hidden = h !== handle; });
      });
      satzJetzt = handle;
      zeigen(satz.fotos[0].dataset.foto);
    }

    // decode() sagt zu, dass das Bild sofort gezeichnet werden kann; "complete" allein
    // sagt das nicht. Liegt es schon im Speicher, ist die Zusage im selben Wimpernschlag
    // da und der Wechsel faellt mit dem Klick zusammen.
    var img = satz.fotos[0].querySelector('img');
    if (!img || (img.complete && img.naturalWidth) || !img.decode) { um(); return; }
    var fertig = false;
    var los = function () { if (!fertig) { fertig = true; um(); } };
    img.decode().then(los, los);
    setTimeout(los, 800);
  }

  function optionWaehlen(o, ersteWahl) {
    var p = o.produkt;
    if (!p) return;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    einzelpreis = v ? v.price : p.price;
    if (el.versand && v && v.weight) el.versand.dataset.gewicht = v.weight;
    grundpreisZeigen(v);
    if (v) el.variante.value = v.id;
    if (el.titelArt) el.titelArt.textContent = artAusTitel(p.title);
    if (el.artikel) el.artikel.textContent = p.title;
    umfangSetzen(p.title);
    preisZeigen();
    if (el.beschreibung && p.description) el.beschreibung.innerHTML = p.description;
    if (!ersteWahl) {
      galerieZeigen(o.handle, p);
      try { history.replaceState({}, '', o.url); } catch (e) {}
      wurzel.dataset.handle = o.handle;
    }
    wurzel.querySelectorAll('.dp-ausf-knopf').forEach(function (k) {
      var an = k.dataset.handle === o.handle;
      k.classList.toggle('jetzt', an);
      k.setAttribute('aria-checked', an ? 'true' : 'false');
      k.tabIndex = an ? 0 : -1;
    });
    // Die sichtbare Zeile "Ausführung: …" ist seit 08.10.2026 weg; ds-zweifarb.js liest den Namen hier.
    wurzel.dataset.ausfuehrung = o.name;
    ausfName = o.name;
    if (el.leisteTitel) { el.leisteTitel.textContent = o.name; el.leisteTitel.hidden = false; }
  }

  function preisVon(o) {
    if (!o.produkt) return 0;
    var v = (o.produkt.variants || []).filter(function (x) { return x.available; })[0] || (o.produkt.variants || [])[0];
    return v ? v.price : o.produkt.price;
  }

  // Jede Karte zeigt den vollen Preis ihrer Ausfuehrung, nicht den Aufpreis zur gerade gewaehlten
  // (bis 05.10.2026 "+4,00 €"): der volle Preis aendert sich beim Wechsel nicht, und niemand muss rechnen.
  function ausfuehrungenZeichnen() {
    if (optionen.length < 2) return;
    optionen.sort(function (x, y) { return x.rang - y.rang; });
    var box = wurzel.querySelector('[data-ausfuehrungen]');
    var liste = box.querySelector('[data-ausf-liste]');
    liste.innerHTML = optionen.map(function (o) {
      var jetzt = o.handle === cfg.handle;
      return '<button type="button" class="dp-ausf-knopf' + (jetzt ? ' jetzt' : '') + '" role="radio" aria-checked="' +
        (jetzt ? 'true' : 'false') + '" tabindex="' + (jetzt ? '0' : '-1') + '" data-handle="' + o.handle + '">' +
        '<b>' + o.name + '</b><span class="dp-ausf-preis">' + (preisVon(o) ? euroAusCent(preisVon(o)) : '') + '</span></button>';
    }).join('');
    liste.querySelectorAll('.dp-ausf-knopf').forEach(function (k) {
      function holen() {
        return optionen.filter(function (x) { return x.handle === k.dataset.handle; })[0];
      }
      k.addEventListener('click', function () {
        var o = holen();
        if (o) optionWaehlen(o, false);
      });
      // Wer den Zeiger auf den Knopf legt, klickt ihn meistens auch. Bis dahin ist das
      // Bild geladen und der Wechsel geschieht ohne Warten.
      var vorbereiten = function () {
        var o = holen();
        if (o && o.produkt) satzBauen(o.handle, o.produkt);
      };
      k.addEventListener('pointerenter', vorbereiten, { once: true });
      k.addEventListener('focus', vorbereiten, { once: true });
    });
    // Auch ohne Zeiger - auf dem Handy gibt es keinen - liegen die Bilder nach kurzer
    // Zeit bereit. Spaet genug, dass sie dem ersten Bild der Seite nichts wegnehmen.
    setTimeout(function () {
      optionen.forEach(function (o) { if (o.produkt) satzBauen(o.handle, o.produkt); });
    }, 1500);
    liste.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var k = [].slice.call(liste.querySelectorAll('.dp-ausf-knopf'));
      var i = k.indexOf(document.activeElement);
      var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + k.length) % k.length;
      k[n].focus(); k[n].click();
    });
    var hinweis = box.querySelector('[data-ausf-hinweis]');
    if (hinweis && hinweis.textContent.trim()) hinweis.hidden = !optionen.some(function (o) { return o.rang === 3; });
    box.hidden = false;
  }

  // Gleiche Farbe = gleicher Titelkopf (Titel ohne Packungsteil). Der Farbcode allein reicht nicht:
  // Standox-Codes sind nicht eindeutig (Land Rover 663 = Spectral Lime, Autobiography Green, British
  // Racing Green), und die Suche nach Code und Marke liefert alle. Ohne diesen Vergleich zeigten am
  // 05.10.2026 auf der Seite "Autobiography Green" beide Knoepfe auf Spectral Lime (im Shop rund 2.000
  // solche Paare). Ein Set mit Grundierung traegt den Titel seines Standard-Sets plus Packung.
  function titelKopf(titel) {
    var t = String(titel || '').toUpperCase();
    var m = t.search(/\s\d+\s?ML\b|\s?\+\s?KLARLACK|\s\d+X\d+\s?ML\b/);
    if (m > 0) t = t.slice(0, m);
    t = t.replace(/^LACKSTIFT(\s+SET)?\s+(PASSEND\s+)?F(Ü|UE|U)R\s+/, '');
    t = t.replace(/\b(METALLIC|PERLEFFEKT|UNI|MATT)\b/g, ' ');
    return t.replace(/[^A-Z0-9ÄÖÜ]+/g, '');
  }

  // Der Titelkopf als Suchtext (Marke, Code und Farbname, ohne Packung und ohne "Lackstift ... fuer").
  function titelKopfText(titel) {
    var t = String(titel || '').toUpperCase();
    var m = t.search(/\s\d+\s?ML\b|\s?\+\s?KLARLACK|\s\d+X\d+\s?ML\b/);
    if (m > 0) t = t.slice(0, m);
    t = t.replace(/^LACKSTIFT(\s+SET)?\s+(PASSEND\s+)?F(Ü|UE|U)R\s+/, '');
    return t.replace(/[^A-Z0-9ÄÖÜ]+/g, ' ').trim();
  }

  function ausfuehrungenLaden(markeWort, code) {
    if (ausfGelaufen || !markeWort || !code) return;
    ausfGelaufen = true;
    var codeN = norm(code);
    var markeGross = markeWort.toUpperCase();
    var eigenerKopf = titelKopf(cfg.titel);
    var sucheUrl = function (q) {
      return cfg.suche + '/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10&resources[options][fields]=title&resources[options][unavailable_products]=hide';
    };
    var auswerten = function (j) {
      var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
      var gesehen = {};
      return ps.filter(function (p) {
        var t = p.title.toUpperCase();
        return t.indexOf('LACKSTIFT') === 0 && titelTraegtCode(t, codeN) && t.indexOf(markeGross) >= 0 &&
          titelKopf(p.title) === eigenerKopf;
      }).map(function (p) {
        var a = artVon(p.title);
        return { name: a.name, rang: a.rang, handle: p.handle, url: p.url.split('?')[0] };
      }).filter(function (o) {
        if (gesehen[o.name]) return false;
        gesehen[o.name] = true;
        return true;
      });
    };
    var holen = function (q) {
      return fetch(sucheUrl(q), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(auswerten);
    };
    // Zuerst nach dem ganzen Titelkopf: bei Codes mit vielen Farben ("Ford 3") stehen die Geschwister sonst oft nicht unter
    // den zehn Treffern der Suche nach Code und Marke. Bringt das keine zwei Ausfuehrungen, wie bisher nach Code und Marke.
    var kopfText = titelKopfText(cfg.titel);
    (kopfText ? holen(kopfText) : Promise.resolve([])).then(function (treffer) {
      if (treffer.length >= 2) return treffer;
      return holen(code + ' ' + markeWort);
    }).then(function (treffer) {
      if (treffer.length < 2) return null;
      return Promise.all(treffer.map(function (o) {
        return fetch('/products/' + o.handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { o.produkt = p; return o; })
          .catch(function () { return o; });
      })).then(function (fertig) {
        optionen = fertig.filter(function (o) { return o.produkt; });
        if (optionen.length < 2) return;
        ausfuehrungenZeichnen();
        var jetzt = optionen.filter(function (o) { return o.handle === cfg.handle; })[0];
        if (jetzt) optionWaehlen(jetzt, true);
      });
    }).catch(function () {});
  }

  // Ohne Farbtreffer: Marke und Code aus dem Titel schätzen
  function ausfuehrungenAusTitel() {
    if (ausfGelaufen) return;
    var T = cfg.titel.toUpperCase();
    var m = T.match(/^LACKSTIFT(?:\s+SET)?\s+(?:F(?:Ü|U)R|PASSEND\s+F(?:Ü|U)R)\s+(.+)$/);
    if (!m) return;
    var rest = m[1].split(/\s+/), markeTeile = [], code = null;
    for (var i = 0; i < rest.length && i < 4; i++) {
      var w = rest[i];
      if (/\d/.test(w)) { code = w; break; }
      if (/^[A-ZÄÖÜ]{2,}$/.test(w)) { markeTeile.push(w); continue; }
      code = w; break;
    }
    if (!code && rest.length > markeTeile.length) code = rest[markeTeile.length];
    if (markeTeile.length && code) ausfuehrungenLaden(markeTeile.join(' '), code);
  }
  setTimeout(ausfuehrungenAusTitel, 3000);

  /* ---------- Varianten eines Produkts (Groesse, Koernung), seit 25.10.2026 ---------- */
  // Bis dahin war bei Zubehoer mit mehreren Varianten nur die erste kaufbar (Gold-Schleifscheiben: neun Koernungen,
  // keine Auswahl). Die Knoepfe stehen im Liquid, die Varianten als JSON darunter (dasselbe Format wie /products/<handle>.js).
  (function () {
    var box = wurzel.querySelector('[data-varianten]');
    if (!box || !el.variante) return;
    var liste = [];
    try { liste = JSON.parse(box.querySelector('[data-varianten-daten]').textContent) || []; } catch (e) { return; }
    if (!liste.length) return;
    var gruppen = [].slice.call(box.querySelectorAll('[data-option]'));
    // Stück je Packung je Variante (seit 27.10.2026, Variantenfeld custom.packung_stueck; 0 = einzeln) für „Inhalt: 50 Stück“ am Preis
    var packung = {};
    try { packung = JSON.parse((box.querySelector('[data-packung-daten]') || {}).textContent || '{}'); } catch (e) {}
    var inhalt = wurzel.querySelector('[data-inhalt]');
    var knopfText = el.kaufen.getAttribute('data-knopf-text') || 'In den Warenkorb';
    // Fotos aus der Liquid-Schleife tragen data-foto="0" … "3"; Variantenbilder dahinter "v<id>".
    var fotoZahl = [].filter.call(el.buehne.querySelectorAll('.dp-foto[data-foto]'), function (f) { return /^\d+$/.test(f.dataset.foto); }).length;

    function werteJetzt() {
      return gruppen.map(function (g) { var r = g.querySelector('input:checked'); return r ? r.value : null; });
    }
    function passend(werte) {
      return liste.filter(function (x) { return x.options.every(function (o, i) { return o === werte[i]; }); })[0];
    }
    // Ein Wert gilt als lieferbar, wenn es ihn zusammen mit den uebrigen gewaehlten Werten lieferbar gibt.
    function lieferbarMarken(werte) {
      gruppen.forEach(function (g, i) {
        g.querySelectorAll('input').forEach(function (r) {
          var probe = werte.slice(); probe[i] = r.value;
          var x = passend(probe);
          r.closest('.dp-wert').classList.toggle('aus', !(x && x.available));
        });
      });
    }
    function preisAltZeigen(x) {
      var alt = wurzel.querySelector('[data-preis-alt]');
      var zeigen = x.compare_at_price && x.compare_at_price > x.price;
      if (!alt && zeigen) {
        alt = document.createElement('s');
        alt.className = 'dp-preis-alt';
        alt.setAttribute('data-preis-alt', '');
        el.preis.insertAdjacentElement('afterend', alt);
      }
      if (!alt) return;
      alt.hidden = !zeigen;
      if (zeigen) alt.textContent = euroAusCent(x.compare_at_price);
    }
    // Galerie je Variante (29.10.2026): Vorschauen mit data-variante gehören einer Variante; nur die der gewählten bleibt sichtbar.
    var varThumbs = [].slice.call(wurzel.querySelectorAll('.dp-thumb[data-variante]'));
    function bildZeigen(x) {
      varThumbs.forEach(function (t) { t.hidden = t.dataset.variante !== String(x.id); });
      if (el.buehne.querySelector('.dp-foto[data-foto="v' + x.id + '"]')) { zeigen('v' + x.id); return; }
      if (varThumbs.length) { if (el.buehne.querySelector('.dp-foto[data-foto="0"]')) zeigen('0'); return; }
      var b = x.featured_image;
      if (!b || !b.position) return;
      if (b.position <= fotoZahl) zeigen(String(b.position - 1));
    }
    function varianteZeigen(x, wechsel) {
      el.variante.value = x.id;
      el.variante.disabled = !x.available;
      einzelpreis = x.price;
      if (el.versand) el.versand.dataset.gewicht = x.weight || 0;
      grundpreisZeigen(x);
      preisAltZeigen(x);
      if (inhalt) {
        var stueck = Number(packung[x.id]) || 0;
        inhalt.hidden = !stueck;
        if (stueck) inhalt.querySelector('[data-inhalt-zahl]').textContent = stueck;
      }
      el.kaufen.disabled = !x.available;
      var schrift = el.kaufen.querySelector('span');
      if (schrift) schrift.textContent = x.available ? knopfText : 'Zurzeit nicht verfügbar';
      gruppen.forEach(function (g, i) {
        g.querySelectorAll('input').forEach(function (r) { r.checked = r.value === x.options[i]; });
      });
      lieferbarMarken(x.options);
      if (el.leisteTitel) { el.leisteTitel.textContent = x.title; el.leisteTitel.hidden = false; }
      preisZeigen();
      if (wechsel) {
        bildZeigen(x);
        try {
          var u = new URL(location.href);
          u.searchParams.set('variant', x.id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }
    }

    box.addEventListener('change', function (e) {
      var werte = werteJetzt();
      var x = passend(werte);
      if (!x) {
        // Die Kombination gibt es nicht: die erste (lieferbare) Variante mit dem eben gewaehlten Wert nehmen.
        var i = gruppen.indexOf(e.target.closest('[data-option]'));
        var mitWert = liste.filter(function (y) { return y.options[i] === werte[i]; });
        x = mitWert.filter(function (y) { return y.available; })[0] || mitWert[0];
      }
      if (x) varianteZeigen(x, true);
    });

    var start = liste.filter(function (x) { return String(x.id) === String(el.variante.value); })[0] || liste[0];
    varianteZeigen(start, false);
    // Kommt man ueber einen Link mit ?variant=… (z. B. die Weiterleitungen der alten Einzelseiten), zeigt die Buehne gleich
    // deren Bild. Ohne Parameter bleibt das erste Foto vorn.
    if (/[?&]variant=/.test(location.search)) bildZeigen(start);
  })();

  /* ---------- Einzelpreis aus dem eigenen Produkt, damit die Menge sofort rechnet ---------- */
  fetch('/products/' + cfg.handle + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || einzelpreis !== null) return;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      einzelpreis = v ? v.price : p.price;
      preisZeigen();
    }).catch(function () {});
})();
